import Helpers from '../../javascripts/lib/helpers';
import BasketButtonAnimator
  from '../../javascripts/application/shop/basket-button-animator';

Helpers.ready(() => {
  new BasketButtonAnimator({ selector: '[data-js-add-to-basket]' });
});
